import { defineMessages } from 'react-intl'

export default defineMessages({
    postalCodePlaceholder: {
        defaultMessage: 'Código Postal',
    },
    requiredError: {
        defaultMessage: 'Debes indicar el código postal.',
    },
    lengthError: {
        defaultMessage: 'El código postal debe contener máximo 10 caracteres.*',
    },
    postalCodeLabel: {
        defaultMessage: 'Código Postal',
    },
})
